import { render, staticRenderFns } from "./directional-graph2.vue?vue&type=template&id=677a5844&scoped=true"
import script from "./directional-graph2.vue?vue&type=script&lang=js"
export * from "./directional-graph2.vue?vue&type=script&lang=js"
import style0 from "./directional-graph2.vue?vue&type=style&index=0&id=677a5844&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677a5844",
  null
  
)

export default component.exports